import React from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon } from 'lucide-react';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-brand-black/95 backdrop-blur-sm border-b border-brand-border" data-id="element-160">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20 h-20 flex items-center justify-between" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="flex items-center gap-3 cursor-pointer" data-id="element-162">
          <div className="w-10 h-10 bg-brand-grey rounded flex items-center justify-center border border-brand-border" data-id="element-163">
            <WrenchIcon className="w-5 h-5 text-brand-accent" data-id="element-164" />
          </div>
          <div className="flex flex-col" data-id="element-165">
            <span className="font-heading font-bold text-lg leading-none tracking-industrial text-brand-white uppercase" data-id="element-166">
              Ionuț Drăgănescu
            </span>
            <span className="font-body text-xs text-brand-muted uppercase tracking-widest mt-1" data-id="element-167">
              Meseriaș Profi
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="hidden md:block" data-id="element-168">
          <a href="https://wa.link/udb2nf" target="_blank" rel="noopener noreferrer" className="inline-block bg-transparent border border-brand-accent text-brand-accent font-heading font-bold uppercase text-sm tracking-industrial px-6 py-2.5 rounded-[4px] hover:bg-brand-accent hover:text-brand-black transition-colors duration-300" data-id="element-169">
            Sesiune Gratuită
          </a>
        </motion.div>
      </div>
    </nav>;
}